import { createContext, useEffect, useState } from 'react';
import topApi from '../../components/api/ToPApi';
import { Link, LinkPagoExternalResponse, LinkPagoResponse, LinksPagoResponse, Payment3dsResponse, PaymentResponse, VoidResponse } from '../../models/interfaces';
import Message from '../../components/ui/Message';




type LinkPagoContextProps = {
    isLoading: boolean;
    isLoadingAutorization: boolean;
    linkPagos: Link[];
    linkExternal: Link;
    isRequireName: boolean;
    loadLinkPagoExternal: (req: any) => Promise<string>;
    loadLinkPagoSession: (req: any) => Promise<string>;
    loadLinksPago: (req: any) => Promise<void>;
    loadLinkPagoHoy: () => Promise<void>;
    voidLinkPago: (link_id: number) => Promise<string>;
    cancelLinkPago: (link: any) => Promise<string>;
    createLinkPago: (link: any) => Promise<string>;
    autorizationLink: (card: any, linkToken: string) => Promise<PaymentResponse>;
    //paymentLink: (link: any, linkToken: string) => Promise<string>;
    getResult3ds: (clientId: string) => Promise<PaymentResponse>;
    voidAutorizationLink: (card: any) => Promise<VoidResponse>;


}

export const LinkPagoContext = createContext({} as LinkPagoContextProps);
export const TransactionsContext = createContext({} as LinkPagoContextProps);

export const LinkPagoProvider = ({ children }: any) => {

    const [linkPagos, setLinks] = useState<Link[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isLoadingAutorization, setIsLoadingAutorization] = useState<boolean>(false);

    const [linkExternal, setLinkExternal] = useState<Link>(null);
    const [customToken, setCustomToken] = useState<string>("");
    const [isRequireName, setIsRequireName] = useState(false);


    const loadLinkPagoExternal = async (linkToken: string) => {
        let message = "success";
        try {

            setIsLoading(true)
            const resp = await topApi.get<LinkPagoExternalResponse>('/linkpago/getLinkExternal/' + linkToken);
            if (resp.status == 200) {
                if (resp.data.link.statusCode == 0) {
                    setLinkExternal(resp.data.link.datos);
                    setCustomToken(resp.data.link.customToken);
                    setIsRequireName(resp.data.link.requireName);
                } else {
                    message = resp.data.link.mensaje;
                }
            }
            setIsLoading(false)
        } catch (error) {
            message = "Ocurrió un error consultando el link de pagos, intente de nuevo."
            setIsLoading(false)
        }
        return message;
    }

    const loadLinkPagoSession = async (linkToken: string) => {
        let message = "success";
        try {

            setIsLoading(true)
            const resp = await topApi.get<LinkPagoExternalResponse>('/linkpago/getLinkSession/' + linkToken);
            if (resp.status == 200) {

                setLinkExternal(resp.data.link.datos);


            }
            setIsLoading(false)
        } catch (error) {
            message = "La informacion de este link de pagos ya no se encuentra disponible."
            setIsLoading(false)
        }
        return message;
    }

    const loadLinksPago = async (req: any) => {
        try {
            setLinks([]);
            setIsLoading(true)
            const resp = await topApi.post<LinksPagoResponse>('/linkpago/getLinks', req);
            if (resp.status == 200) {
                setLinks(resp.data.links);
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }

    }

    const loadLinkPagoHoy = async () => {
        try {
            setLinks([]);
            setIsLoading(true)
            const resp = await topApi.get<LinksPagoResponse>('/linkpago/paymentToday');
            if (resp.status == 200) {
                setLinks(resp.data.links);
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }

    }

    const voidLinkPago = async (link_id: number) => {
        let message = "";
        try {
            setIsLoading(true)
            const resp = await topApi.post('/linkpago/void/' + link_id);
            if (resp.status == 200) {
                message = resp.data.link.mensaje;
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            message = "Ocurrió un error anulando el link de pago."
        } finally {
            return message;
        }

    }

    const cancelLinkPago = async (link: any) => {
        let message = "";
        try {
            setIsLoading(true)
            const resp = await topApi.post('/linkpago/cancel', { link });
            if (resp.status == 200) {
                message = resp.data.message;
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            message = "Ocurrió un error anulando el link de pago."
        } finally {
            return message;
        }

    }

    const createLinkPago = async (link: any) => {
        let message = "";
        try {
            setIsLoading(true)
            const resp = await topApi.post<LinkPagoResponse>('/linkpago/', { link });
            if (resp.status == 200) {
                if (resp.data.link.linkId != null) {
                    message = "success";
                }

            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            message = "Ocurrió un error anulando el link de pago."
        } finally {
            return message;
        }

    }

    const autorizationLink = async (card: any, linkToken: string) => {
        try {
            setIsLoadingAutorization(true)
            const req = {
                card,
                token: customToken,
                solicita: "web",
                clientId: crypto.randomUUID().replace(/-/g, ''),
                link: linkExternal,
                linkToken
            }
            const resp = await topApi.post<PaymentResponse>('/card/paymentLink', req);
            if (resp.status == 200) {
                setIsLoadingAutorization(false)
                return resp.data;
            }
            setIsLoadingAutorization(false)
        } catch (error) {
            setIsLoadingAutorization(false)
        }
    }

    /*const paymentLink = async (link: any, linkToken: string) => {
        let message = 'No se completó correctamente el pago del link.';

        try {
            setIsLoading(true)
            const req = {
                link
            }
            const resp = await topApi.post<any>('/linkpago/payment/' + linkToken, req);
            if (resp.status == 200) {
                setIsLoading(false)
                message = "success";
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        } finally {
            return message
        }
    }*/

    const getResult3ds = async (clientId: string) => {
        try {
            setIsLoading(true)
            const resp = await topApi.get<Payment3dsResponse>('/card/getResult3ds/' + clientId);
            if (resp.status == 200) {
                setIsLoading(false)
                return resp.data.payResponse;
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }

    const voidAutorizationLink = async (card: any) => {
        try {
            setIsLoading(true);
            const token = await localStorage.getItem('token');
            const req = {
                card,
                token: token
            }
            const resp = await topApi.post<VoidResponse>('/card/voidExternal', req);
            if (resp.status == 200) {
                setIsLoading(false)
                return resp.data;
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }



    return (
        <LinkPagoContext.Provider value={{
            isLoading,
            isLoadingAutorization,
            linkPagos,
            linkExternal,
            loadLinkPagoExternal,
            loadLinkPagoSession,
            loadLinksPago,
            loadLinkPagoHoy,
            voidLinkPago,
            createLinkPago,
            cancelLinkPago,
            autorizationLink,
            //paymentLink,
            getResult3ds,
            voidAutorizationLink,
            isRequireName
        }}>
            {children}
        </LinkPagoContext.Provider>
    );
}